import { render, staticRenderFns } from "./EditCoupon.vue?vue&type=template&id=84d5f81c"
import script from "./EditCoupon.vue?vue&type=script&lang=js"
export * from "./EditCoupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports